// extracted by mini-css-extract-plugin
export default {"container":"footer_container__tTpaG","footerContainer":"footer_footerContainer__--Xv7","copyright":"footer_copyright__M+rPc","quickLinks":"footer_quickLinks__4xv1L"};